const init = () => {
  $(document).ready(() => {
    window.dispatchEvent(new CustomEvent('parseHighlightTitle', {}));
  });
  window.addEventListener('parseHighlightTitle', () => {
    const items = document.querySelectorAll('.js_highlight_helper.hidden');
    Array.from(items).forEach(item => {
      const replacedText = $(item).removeClass('hidden')
        .text()
        .replace(/</gi, '&lt;')
        .replace(/>/gi, '&gt;')
        .replace(/&lt;strong([^&]*)&gt;(.*?)&lt;\/strong&gt;/gi, '<strong$1>$2</strong>');
      item.innerHTML = replacedText;
    });
  });
};
export default init;



// WEBPACK FOOTER //
// ./util/highlightingHelper.js